import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'
import { getUserSessionState, getUserErrorState } from '../../../selectors/user'
import { loginTrigger } from '../../../actions'

import { Login } from '../../../components/pages/Login/Login'

const mapStateToProps = (state: RootState) => {
  return {
    loading: getAppLoading(state),
    userSession: getUserSessionState(state),
    userError: getUserErrorState(state),
    recoverSuccess: state.user.recoverSuccess,
  }
}

export default connect(mapStateToProps, { login: loginTrigger })(Login)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Login/Login.tsx